<div class="container-fluid">
  <div class="d-md-none my-3">
    <div class="d-flex justify-content-center">
      <div style="width: 79px;height: 5px; border-radius: 41px; background-color: #D9D9D9"></div>
    </div>
  </div>
  <div class="d-flex align-items-center mt-md-2">
    <img src="assets/imgs/icones/info-azul.svg" class="me-3">
    <span class="modal-title">{{tituloConfirmarAcao}}</span>
  </div>
  <div class="container-fluid h-100 overflow-hidden d-flex flex-column justify-content-between" >
    <div class="p-1">
      <div class="mb-2">
        <div class="mt-3">
          <span class="text-black" [innerHTML]="descricaoConfirmarAcao"></span>
        </div>
      </div>
    </div>
    <div class="text-center mb-3 mt-2">
      <div class="row">
        <div class="col-6">
          <button type="button" id="btnFecharDetalhes" class="btn btn-outline-secondary btn-sm w-100" (click)="fechar()">Voltar</button>
        </div>
        <div class="col-6">
          <button type="button" id="btnCancelar" class="btn btn-primary btn-sm w-100" (click)="enviar()">Confirmar</button>
        </div>
      </div>
    </div>
  </div>

</div>
